// Invalid chars for uploading filename
// The remix server will fail to parse the form data if the upload filename includes `=` or `;`.
// https://github.com/remix-run/remix/issues/4443
export const INVALID_CHARS_FOR_FILENAME: string[] = ['=', ';'];
